export const targetAllocationMutationKeys = {
  all: () => ["allocationWindow"],
  deleteAllocationWindow: () => [...targetAllocationMutationKeys.all(), "delete"],
  createAllocationWindow: () => [...targetAllocationMutationKeys.all(), "create"],
  updateAllocationWindow: () => [...targetAllocationMutationKeys.all(), "update"]
};
